import React from "react";
import { shape } from "../../utils/map/shapes";

export const Caption = ({legendsValues, selectedItem, addressInfos}) => {

    const formatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0})
    const colors = addressInfos.com.com != '75056'
        ? ["#EBED8C", "#EADA4A", "#E3B130", "#FF0000", "#8E0000"]
        : ["#EAEC83", "#DBDB04", "#FFCE03", "#FD9A01", "#D94500", "#FF2C05", "#F00505", "#980404", "#590303", "#230000"];

    return (
        <div id="modal-legend" aria-hidden="true" aria-modal='true' className='modal fade' role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title heading type6 mb-0">
                            <span>{selectedItem.label}</span>
                        </h1>
                        <button type="button" data-dismiss="modal" aria-label="Fermer" className="close">
                            <i className="maificon maificon-cross"></i>
                            <span className="sr-only">Informations</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {selectedItem && legendsValues &&
                            <div className="mb-3">
                                {legendsValues.map(v =>
                                    <div class="d-flex align-items-start mt-1">
                                        <span className="shape-legend" dangerouslySetInnerHTML={{ __html: shape(v.shape, v.color)}}></span>
                                        <p className="my-0 px-2 col-11">{v.label}</p>
                                    </div>
                                )}
                                {selectedItem.details && <div className="my-3" dangerouslySetInnerHTML={{ __html: selectedItem.details }} />}
                            </div>
                        }
                        {selectedItem && selectedItem.id === 'immobilier' &&
                            <div className="mb-3">
                                <h1 className="modal-title mb-2 fw-bold">Estimation immobilière ({selectedItem.typeHabitat.charAt(0).toUpperCase()}{selectedItem.typeHabitat.substring(1)} de {selectedItem.surface}m&sup2;)</h1>
                                <div className="estimate-legend-container mb-4">
                                        <h3>Estimation des prix</h3>
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary">Basse</span>
                                                <span><strong>&lt; { formatter.format(Math.min(...selectedItem.data.estimates.map(e => e.prix_m2))) }/m&sup2;</strong></span>
                                            </div>
                                            <div className="d-flex flex-column">
                                                <span className="text-secondary text-right">Haute</span>
                                                <span><strong>&lt; { formatter.format(Math.max(...selectedItem.data.estimates.map(e => e.prix_m2))) }/m&sup2;</strong></span>
                                            </div>
                                        </div>
                                        <div className="estimate-colors-container mt-2">
                                            {colors.map(color => <span className="estimate-color-item" key={color} style={{"--estimate-color": color}}></span>)}
                                        </div>
                                    </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}